module.exports = __webpack_public_path__ + "static/media/App.0be349ba.less";